<script>
import { QcItemServiceProxy } from '@/service-proxies/app-v2/product.service-proxies'
const qcisp = new QcItemServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'action',
    width: 80,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'page_bussiness_data_quality_name_of_quality',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: 'page_bussiness_data_quality_standard_value',
    dataIndex: 'standardValue',
    scopedSlots: { customRender: 'standardValue' }
  }
]
export default {
  data() {
    return {
      dataSource: [],
      total: 0,
      count: 1,
      filter: {
        current: 1,
        size: -1
      },
      loading: false
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  props: {
    selectedId: {
      type: String,
      default: ''
    },
    scrollY: {
      type: Number,
      default: 0
    },
    qualityData: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    selectedId: {
      handler() {
        if (this.selectedId) {
          if (this.selectedId.indexOf('add') === -1) {
            this.filter.current = 1
            this.getData()
          } else {
            console.log(this.qualityData, this.selectedId)
            this.dataSource = this.qualityData[this.selectedId] || []
            this.count = this.dataSource.length + 1
            this.$emit('addQualityData', this.dataSource)
          }
        } else {
          this.dataSource = this.qualityData[this.selectedId] || []
          this.count = this.dataSource.length + 1
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getData() {
      this.dataSource = []
      this.loading = true
      const res = await qcisp.getPageQcItem(this.filter.current, this.selectedId, this.filter.size)
      this.dataSource = res.records.map((res, index) => {
        res.id = index + 'edit'
        return res
      })
      const itemList = this.qualityData[this.selectedId]
      if (itemList && itemList.length) {
        const items = this.qualityData[this.selectedId].filter((res) => res.qcProcessId !== '')
        this.dataSource = [...items]
      }
      this.total = this.dataSource.length - 1
      this.count = this.total + 1
      this.loading = false
      this.$emit('addQualityData', this.dataSource)
    },
    onDelete(key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.id !== key)
      this.$emit('addQualityData', this.dataSource)
    },
    handleAdd() {
      const { count, dataSource } = this
      const newData = {
        id: count + 'add',
        name: '',
        standardValue: ''
      }
      this.dataSource = [newData, ...dataSource]
      this.count = count + 1
    },
    handleChange(value, key, column) {
      const newData = [...this.dataSource]
      const target = newData.find((item) => key === item.id)
      if (target) {
        target[column] = value
        if (column === 'standardValue') {
          target[column] = Number(value).toFixed(2)
        }
        this.dataSource = newData
        this.$emit('addQualityData', this.dataSource)
      }
    }
  }
}
</script>

<template>
  <div class="qcquality-table">
    <a-button
      v-acl="'page_product_plan_quality_add_quality'"
      class="editable-add-btn"
      type="default"
      @click="handleAdd"
      :disabled="selectedId === ''"
    >
      {{ $t('page_bussiness_data_quality_add_quality') }}
    </a-button>
    <ml-table
      rowKey="id"
      :columns="columns"
      :data-source="dataSource"
      :loading="loading"
      bordered
      :scroll="{ y: scrollY }"
    >
      <template slot="action" slot-scope="text, record">
        <a @click="onDelete(record.id)" style="color: #ff0000;">{{ $t('delete') }}</a>
      </template>
      <template slot="name" slot-scope="text, record">
        <div>
          <a-input
            v-if="record.id && record.id.indexOf('add') !== -1"
            style="100%"
            :value="text"
            @change="(e) => handleChange(e.target.value, record.id, 'name')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="standardValue" slot-scope="text, record">
        <div>
          <a-input-number
            v-if="record.id && record.id.indexOf('add') !== -1"
            style="100%"
            :step="0.01"
            :value="text"
            @change="(value) => handleChange(value, record.id, 'standardValue')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
    </ml-table>
  </div>
</template>

<style scoped>
.editable-add-btn {
  width: 100%;
  margin-bottom: 4px;
}
.qcquality-table {
  position: relative;
  height: 100%;
}
</style>
